import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import "./LearningHubsNewTabs.css";
import CoreHubTab from "./corehubtab/corehubtab.jsx";
import { getCoursesByHub } from "Redux/CourseDetails";
import { isFoundationUnlocked } from "utils/foundationUnlock";

const tabsData = [
  {
    id: "core",
    label: "Core Hub",
    icon: "/Assets/LearningHubs/TabIcons/Foundation.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/Foundation-inactive.png",
  },
  {
    id: "genai",
    label: "GenAI Agentic Hub",
    icon: "/Assets/LearningHubs/TabIcons/AI.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/AI-inactive.png",
  },
  {
    id: "sales",
    label: "Sales & Solutioning Hub",
    icon: "/Assets/LearningHubs/TabIcons/Sales.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/Sales-inactive.png",
    disabled: true,
  },
  {
    id: "delivery",
    label: "Delivery Modernisation Hub",
    icon: "/Assets/LearningHubs/TabIcons/Delivery.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/Delivery-inactive.png",
  },
  {
    id: "future",
    label: "Future of Experience Hub",
    icon: "/Assets/LearningHubs/TabIcons/Future.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/Future-inactive.png",
    disabled: true,
  },
  {
    id: "product",
    label: "Product Hub",
    icon: "/Assets/LearningHubs/TabIcons/Product.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/Product-inactive.png",
    disabled: true,
  },
  {
    id: "digital",
    label: "Digital Customer .Next Hub",
    icon: "/Assets/LearningHubs/TabIcons/DigitalCustomer.png",
    inactiveicon: "/Assets/LearningHubs/TabIcons/DigitalCustomer-inactive.png",
  },
];

const tabComponents = {
  core: CoreHubTab,
  genai: CoreHubTab,
  sales: CoreHubTab,
  delivery: CoreHubTab,
  future: CoreHubTab,
  product: CoreHubTab,
  digital: CoreHubTab,
};

export default function LearningHubsNewTabs() {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("core");
  const [hoveredTab, setHoveredTab] = useState(null);
  const [showUnlockPopup, setShowUnlockPopup] = useState(false);
  const [lockedHubName, setLockedHubName] = useState("");
  const [isHubSwitching, setIsHubSwitching] = useState(false);
  const [hasLoadedHub, setHasLoadedHub] = useState(false);
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const userLevel = activeAccount.idTokenClaims?.jobFamilyDescription;

  const ActiveComponent = tabComponents[activeTab];

  const { coursesByHub } = useSelector((state) => state.courseDetails);
  const userData = useSelector((state) => state.userDetails.userData?.[0]);

  const isFoundationCompleted = useMemo(() => {
    return isFoundationUnlocked({
      coursesByHub,
      userData,
      userLevel,
    });
  }, [coursesByHub, userData, userLevel]);

  const dynamicTabsData = tabsData.map((tab) => {
    if (tab.id !== "core") {
      return { ...tab, disabled: !isFoundationCompleted };
    }
    return tab;
  });

  const activeHubName = useMemo(() => {
    switch (activeTab) {
      case "core":
        return "Foundation";
      case "genai":
        return "GenAI and Agentic AI Hub";
      case "sales":
        return "Sales & Solutioning Hub";
      case "delivery":
        return "Delivery Modernisation Hub";
      case "future":
        return "Future of Experience Hub";
      case "product":
        return "Product Hub";
      case "digital":
        return "Digital Customer .Next Hub";
      default:
        return null;
    }
  }, [activeTab]);

  useEffect(() => {
    dispatch(getCoursesByHub(activeHubName));
  }, [dispatch, activeHubName]);

  const activeHubData = useMemo(() => {
    return coursesByHub?.find((h) => h.hubName === activeHubName);
  }, [coursesByHub, activeHubName]);

  const hasHubContent = !!activeHubData?.courses?.length;

  const showComingSoon = useMemo(() => {
    if (!hasLoadedHub) return false;

    // No hub object OR no courses
    if (!activeHubData) return true;
    if (!activeHubData.courses || activeHubData.courses.length === 0)
      return true;

    return false;
  }, [hasLoadedHub, activeHubData]);

  console.log("activeHubData", activeHubData, "hasHubContent", hasHubContent);
  useEffect(() => {
    setHasLoadedHub(false);
    setIsHubSwitching(true);
  }, [activeTab]);

  useEffect(() => {
    if (!isHubSwitching) return;

    if (coursesByHub) {
      setHasLoadedHub(true);
      setIsHubSwitching(false);
    }
  }, [coursesByHub, activeTab, userData, userLevel]);

  return (
    <>
      <div className="learning-hub-tabs-container">
        <ul className="tabs">
          {dynamicTabsData.map((tab) => (
            <li
              key={tab.id}
              className={`tab 
        ${activeTab === tab.id ? "active" : ""}
        ${tab.disabled ? "disabled" : ""}
      `}
              onClick={() => {
                if (tab.disabled) {
                  setLockedHubName(tab.label);
                  setShowUnlockPopup(true);
                  return;
                }
                setActiveTab(tab.id);
                setIsHubSwitching(true);
              }}
              onMouseEnter={() => !tab.disabled && setHoveredTab(tab.id)}
              onMouseLeave={() => setHoveredTab(null)}
            >
              <div className="tab-left">
                <img
                  src={
                    activeTab === tab.id || hoveredTab === tab.id
                      ? tab.icon
                      : tab.inactiveicon
                  }
                  alt={`${tab.label} icon`}
                  className="tab-icon"
                />
                <span className="tab-label">{tab.label}</span>
              </div>

              {tab.disabled && (
                <span className="lock">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/Assets/LearningHubs/LockKey.png"
                    }
                    alt="LockKey"
                    className="security-lock"
                  />
                </span>
              )}
            </li>
          ))}
        </ul>

        <div className="tab-content" style={{ minHeight: "260px" }}>
          {!hasLoadedHub || isHubSwitching ? (
            <div
              style={{
                height: "260px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: 600,
                color: "#A100FF",
                fontSize: "16px",
              }}
            >
              Loading hub content…
            </div>
          ) : showComingSoon ? (
            <div
              style={{
                height: "260px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: 600,
                color: "#A100FF",
                fontSize: "16px",
              }}
            >
              Coming Soon
            </div>
          ) : (
            ActiveComponent && (
              <ActiveComponent
                {...(activeTab === "core"
                  ? {
                      hubName: "Foundation",
                      hubDesc: {
                        p1: "Ignite is a launchpad for people across ATCI Song to build future-ready capabilities and contribute to digital customer transformation.",
                        p2: "Ignite is a launchpad for people across ATCI Song to build future-ready capabilities.",
                      },
                    }
                  : activeTab === "genai"
                  ? {
                      hubName: "GenAI and Agentic AI Hub",
                      hubDesc: {
                        p1: "Explore the power of Generative AI and agentic systems shaping the future of work. Build a strong foundation, experiment with real-world use cases, and design intelligent solutions. Turn curiosity into capability through hands-on, applied learning.",
                      },
                    }
                  : activeTab === "sales"
                  ? {
                      hubName: "Sales & Solutioning Hub",
                      hubDesc: {
                        p1: "Learn how to think, design, and communicate end-to-end solutions. Strengthen your ability to translate business needs into scalable, impactful outcomes. Practice solutioning skills through real scenarios and structured learning paths.",
                      },
                    }
                  : activeTab === "delivery"
                  ? {
                      hubName: "Delivery Modernisation Hub",
                      hubDesc: {
                        p1: "Reimagine how value is delivered in a fast-changing digital world. Learn modern delivery practices, tools, and ways of working that drive speed and quality. Apply these approaches to build resilient, future-ready delivery models.",
                      },
                    }
                  : activeTab === "product"
                  ? {
                      hubName: "Product Hub",
                      hubDesc: {
                        p1: "Develop a product mindset focused on customer value and continuous learning. Explore product strategy, discovery, delivery, and lifecycle management. Apply practical tools to build products that matter and evolve with user needs.",
                      },
                    }
                  : activeTab === "future"
                  ? {
                      hubName: "Future of Experience Hub",
                      hubDesc: {
                        p1: "Discover how emerging trends are redefining digital experiences. Explore design, technology, and human-centered thinking in action. Create meaningful, future-ready experiences that connect people and purpose.",
                      },
                    }
                  : {
                      hubName: "Digital Customer .Next Hub",
                      hubDesc: {
                        p1: "The Delivery Modernisation Hub focuses on building capabilities required for modern, secure, and client-centric technology delivery. It covers Agile delivery practices across the end-to-end lifecycle, including clarity on readiness, completion, and the effective use of tools and metrics.",
                      },
                    })}
              />
            )
          )}
        </div>
      </div>

      {showUnlockPopup && (
        <div
          className="unlock-hub-backdrop"
          onClick={() => setShowUnlockPopup(false)}
        >
          <div
            className="unlock-hub-popup"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="unlock-hub-content">
              <div className="unlock-hub-top">
                <div className="unlock-hub-header">
                  <img
                    src="/Assets/LearningHubs/warningIcon.png"
                    alt="warning"
                    style={{ height: "3rem" }}
                  />
                  <div className="unlock-hub-text">
                    <span className="unlock-title">Unlock Hub</span>
                    <p className="unlock-desc">
                      To unlock <b>{lockedHubName}</b> you need to complete Core
                      Hub Courses which are mandatory.
                    </p>
                  </div>
                </div>

                <button
                  className="close-btn"
                  onClick={() => setShowUnlockPopup(false)}
                >
                  ×
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
